import React from 'react';
import {Header,Item, Label,  Breadcrumb, Table, Transition, Icon, Segment, Container, Loader, Dropdown, Divider, Form, Dimmer, Button, Grid,Input, Radio, Popup, List} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import locale from 'antd/es/date-picker/locale/es_ES';
const dateFormat = 'DD/MM/YYYY';


const ReporteCurso=({ajaxCallInProgress, strings, errors=[], onChange , busqueda, onBuscar, datos, onShowModalBorrar})=>{


    
	return (
        <Container>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.idUsaurio}>            
                              <label  >{strings?strings["mail"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["mail"]:""} 
                                    name="busqueda"
                                    onChange={onChange}
                                    value={busqueda}
                                    icon='edit'/>
        
                                <br/><br/>
                                <Button  color="black"
                                    onClick={onBuscar}>{strings?strings["buscar"]:""}
								 </Button>    
        
                            </Form.Field>
 
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
             <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{strings?strings["descripcion"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["estatus"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["cuotas"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["accion"]:""}</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>    
              <Table.Body>
                    {datos.map(registro=>
                       <Table.Row>
                            <Table.Cell>
                               
                                    <Segment basic> 
                                            <Label ribbon>{registro.curso}</Label>
                                            <br/>Contenido del curso visualizado:{registro.visuaizado}
                                            <br/>Costo normal: {registro.costoCurso}
                                            <br/>Costo para el alumno: {registro.costoTotal}
                                            <br/>Total pagado: {registro.costoPagado}
                                            <br/>Cuotas: {registro.noCuotas}
                                    </Segment>
                            </Table.Cell>
                            <Table.Cell textAlign="center">{registro.estatus}</Table.Cell>
                            <Table.Cell textAlign="center">{registro.noCuotas}</Table.Cell>
                            <Table.Cell textAlign="center">
                                <List horizontal>

                                    <List.Item>
                                        <Popup
                                            trigger={
                                                <Icon name='trash alternate outline' link 
                                                onClick={()=>onShowModalBorrar(registro.id)} 
                                                size="large" color="red"  />
                                            }
                                            content='Borrar'
                                          />
                                    </List.Item>
                                 </List>
                            </Table.Cell>

                        </Table.Row>
                                              
                                                
                    )}    

                         </Table.Body>
                  </Table> 
        
        
        </Container>
	);
};



export default ReporteCurso;